import { MacroLink } from '../../types/entities';

export interface MacroLinkStateBySymbol {
  loading: boolean;
  loaded: boolean;
  error?: string;
  links: MacroLink[];
}

export const initialMacroLinkStateBySymbol: MacroLinkStateBySymbol = {
  loading: false,
  loaded: false,
  error: undefined,
  links: []
};

export interface MacroLinkState {
  [symbol: string]: MacroLinkStateBySymbol;
}

export const initialMacroLinkState: MacroLinkState = {};
